export const toString = (value: any) => {
  if (value === null || value === undefined) {
    return '';
  }
  return value + '';
};

export const normalizeQuotes = (value: any) => {
  return (
    toString(value)
      .replace(/â€™/gu, "'")
      .replace(/[\u2018\u2019]|\xe2\x80\x98|\xe2\x80\x99/gu, "'")
      .replace(/[\u201C\u201D]|\xe2\x80\x9c|\xe2\x80\x9d/gu, '"')

      .replace(/\xe2\x80\x93/gu, '-')
      .replace(/\xe2\x80\x94/gu, '--')
      .replace(/\xe2\x80\xa6/gu, '...')

      // Next, replace their Windows-1252 equivalents
      .replace(String.fromCharCode(145), "'")
      .replace(String.fromCharCode(146), "'")
      .replace(String.fromCharCode(147), '"')
      .replace(String.fromCharCode(148), '"')

      .replace(String.fromCharCode(150), '-')
      .replace(String.fromCharCode(151), '--')
      .replace(String.fromCharCode(133), '...')
  );
};

export const normalizeWhitespace = (string: any): string =>
  toString(string).replace(/(\s+)/g, ' ').trim();

export const ucFirst = (string: string | null | undefined) => {
  string = toString(string);
  if (string.length === 0) {
    return '';
  }
  return string[0].toUpperCase() + string.substring(1);
};

export const ucWords = (string: any) =>
  toString(string).replace(/\s(\S)|^./g, (a: string) => a.toUpperCase());

export const trim = (string: string, chars: string | string[] = ' \n') => {
  string = toString(string);
  let start = 0,
    end = string.length;

  while (start < end && chars.indexOf(string[start]) >= 0) ++start;

  while (end > start && chars.indexOf(string[end - 1]) >= 0) --end;

  return start > 0 || end < string.length
    ? string.substring(start, end)
    : string;
};

export const emptyToNull = (value: any): string | null => {
  if (value === '' || value === undefined) {
    return null;
  }
  return value;
};

export const normalizeEmail = (email: string): string =>
  toString(email).trim().toLowerCase();

export const normalizePhone = (phone: string): string => {
  phone = toString(phone)
    .trim()
    .replace(/[^0-9]/g, '');

  if (phone.length === 7) {
    return phone.replace(/([0-9]{3})([0-9]{4})/, '$1-$2');
  } else if (phone.length === 10) {
    return phone.replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, '$1-$2-$3');
  }
  return phone;
};

export const constantToLabel = (constant?: string | null): string => {
  return (constant || '')
    .replace(/([a-z])([A-Z])([a-z])/g, '$1 $2$3')
    .replace(/([0-9])([a-zA-Z])/g, '$1 $2')
    .replace(/([a-zA-Z])([0-9])/g, '$1 $2')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(^\w)|(\s+\w)/g, (l: string) => l.toUpperCase());
};

export const booleanToLabel = (boolean?: boolean): string => {
  return boolean ? 'Yes' : 'No';
};
